import i18n from "@/locales";

export const submit = {
  class: {
    current: ""
    , save: "button__icon icon fas fa-plus"
    , update: "button__icon icon fas fa-check"
  }
  , title: {
    current: ""
    , save: i18n.t("view.commons.save")
    , update: i18n.t("view.commons.update")
  }
};

export const submit_modal = {
  class: {
    current: ""
    , save: "button__icon icon fas fa-plus"
    , update: "button__icon icon fas fa-check"
  }
  , title: {
    current: ""
    , save: i18n.t("view.commons.save")
    , update: i18n.t("view.commons.update")
  }
};

export const enabled = {
  visible: false
  , class: {
    current: ""
    , enabled: "button__icon icon mdi mdi-account"
    , disabled: "button__icon icon mdi mdi-account-off"
  }
  , title: {
    current: ""
    , enabled: "Activar"
    , disabled: "Desactivar"
  }
};



// WEBPACK FOOTER //
// ./src/constants/buttons.js